import React, { lazy, Suspense } from "react";

import type { RouteComponentProps } from "react-router-dom";

import RouteLoadingIndicator from "../../components/RouteLoadingIndicator/RouteLoadingIndicator";


const LazyContainer = lazy(() =>
  import(/* webpackChunkName: "landing-routes" */"./Register.container")
);

const Container: React.FC<RouteComponentProps<any, any, any>> = (props: any) =>
  <Suspense
    fallback={<RouteLoadingIndicator />}>
    <LazyContainer {...props} />
  </Suspense>;

export default Container;
